import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "semantic-ui-react";
import tdvs from "../../../api2/tdvs";

export default function TotalEvalMarks(props) {
  const [evalData, setevalData] = useState([]);
  const [partsData, setpartsData] = useState([]);
  const [sumData, setsumData] = useState([]);

  const params = console.log(props, "propspropsprops");

  useEffect(() => {
    getEvalMarksStatus(
      props.match.params.ifqpcode,
      props.match.params.ifregcode,
      props.match.params.ifvalno
    );
  }, []);

  const getEvalMarksStatus = async (qpcode, regcode, valno) => {
    try {
      const res = await tdvs.get(
        "/app.php?a=getEvalMarksStatus&univcode=030" +
          "&qpcode=" +
          qpcode +
          "&dummyno=" +
          regcode +
          "&valno=" +
          valno
      );
      console.log(res);
      if (res.data.error_code === 0) {
        setevalData(res.data.data.sdata);
        setpartsData(res.data.data.pdata);
        setsumData(res.data.data.sum);
      } else {
        alert(res.data.data.msg);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  let row = evalData[0];
  let sum = sumData;
  return (
    <div>
      {evalData.length > 0 ? (
        <Table basic style={{ margin: "10px auto" }}>
          <Table.Body>
            <Table.Row>
              <Table.Cell>QP Code</Table.Cell>
              <Table.Cell>{row.fqpcode}</Table.Cell>
              <Table.Cell>Subject Name</Table.Cell>
              <Table.Cell>{row.fsubname}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Reg. Code</Table.Cell>
              <Table.Cell>{row.fregcode}</Table.Cell>
              <Table.Cell>Max. Marks</Table.Cell>
              <Table.Cell>{row.ftempmax}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      ) : null}

      {evalData.length > 0 ? (
        <Table
          compact
          celled
          structured
          // style={{ width: "40vw", margin: "10px auto" }}
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="center" rowSpan="2">
                Qn. No.
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center" colSpan="3">
                Marks
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell textAlign="center">
                Awarded by Evaluator
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                Allocated by System
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Max. Marks</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          {partsData.map((el) => {
            return (
              <Table.Body key={el.fpartcode}>
                <Table.Row positive key={el.fpartcode}>
                  <Table.Cell colSpan="4" textAlign="center">
                    {el.fpartdesc} (Answer {el.fmandqn} / {el.fmaxqn} questions)
                  </Table.Cell>
                </Table.Row>
                {evalData.map((row) => {
                  if (el.fpartcode == row.fpartcode && row.fsubqn != "T") {
                    return (
                      <Table.Row key={row.fqncode}>
                        <Table.Cell textAlign="center">{row.fqnno}</Table.Cell>
                        <Table.Cell textAlign="center">
                          {parseFloat(row.fmarks11) == -2
                            ? "NA"
                            : parseFloat(row.fmarks11)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {parseFloat(row.fmarks12) == -2
                            ? "NA"
                            : row.fmarks12 == ""
                            ? ""
                            : parseFloat(row.fmarks12)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {parseFloat(row.fmaxmarks)}
                        </Table.Cell>
                      </Table.Row>
                    );
                  }
                })}
                <Table.Row warning key={el.fpartcode + 1}>
                  <Table.Cell textAlign="center">Part Total</Table.Cell>
                  <Table.Cell textAlign="center">
                    {parseFloat(el.fmarks11)}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {parseFloat(el.fmarks12)}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {parseFloat(el.fmaxmarks)}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            );
          })}

          {sumData.length > 0 ? (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell textAlign="center">
                  Final Marks
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center">
                  {parseFloat(sum[0].ftotmarks)}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center">
                  {parseFloat(sum[0].fsysmarks)}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center">
                  {parseFloat(row.ftempmax)}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          ) : null}
        </Table>
      ) : null}
    </div>
  );
}
